import { ConfirmOptions } from 'material-ui-confirm';

export const confirmYesNo: ConfirmOptions = {
  confirmationButtonProps: { variant: 'contained', fullWidth: true },
  cancellationButtonProps: { variant: 'outlined', fullWidth: true },
  dialogActionsProps: { sx: { px: 3, pb: 3 } },
  dialogProps: { maxWidth: 'xs' },
};
